import { IPrimaryOrder, IPrimaryOrderProduct } from '../../api/types/fanAccount/responseTypes';

export class AccountEvent {
  constructor(
    public data: IPrimaryOrderProduct,
    public orders: IPrimaryOrder[],
  ) {
  }
}
